import styled, { css } from 'styled-components';

const ToolBarButton = styled.div`
  display: flex;
  height: auto;
  cursor: pointer;
  display: flex;
  padding: 0px 16px;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  color: var(--accent-color-blue);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  height: 60px;
  ${(props) =>
    !!props.withBorder &&
    css`
      border-left: 1px solid var(--accent-color-gray);
    `}
`;

export default ToolBarButton;
